// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_RIG","cls2":"PackPreviewRows-cls2_8C8 PackPreviewRows-cls1_RIG"};